<template>
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      title="Delete Category"
      text="Are you sure you want to delete this Category?"
      text_class="text-xl font-medium"
    />
  </transition>
  <ModalAddEditCategory
    ref="modal"
    v-if="modalShowAddEditCategory"
    :categoryData="category_to_edit"
    @openAlertSuccess_CategoryCreated="openAlert_CategoryCreated"
    @openAlertSuccess_CategoryUpdated="openAlert_CategoryUpdated"
    @closeModal="closeModalAddEditCategory"
  />
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader
      class="col-span-2 sm:col-span-1 lg:col-span-2"
      title="Category"
      subtitle=""
    />
    <div class="col-span-2 sm:col-span-1 lg:col-span-2 flex justify-end items-end">
      <Button
        button_id="add-category"
        button_text="&#43; New Category"
        @click="showModalAddEditCategory()"
        class="w-full md:w-auto"
      />
    </div>
    <Card card_class="col-span-2 lg:col-span-4">
      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <DinamicTable :header_columns="table_header" th_class="text-left">
        <TableRow v-if="allCategories.length <= 0">
          <td
            colspan="7"
            class="p-3 text-center italic text-white tracking-widest"
          >
            ~ No data available ~
          </td>
        </TableRow>
        <TableRow v-for="(category, index) in allCategories" :key="index">
          <TableCell>{{ index + 1 }}</TableCell>
          <TableCell>{{ category?.name }}</TableCell>
          <TableCell class="flex gap-2">
            <TableButtonEdit
              path="#"
              :container_id="`btnEditCategory-${index}`"
              @click="editCategory(category)"
            />
            <TableButtonDelete
              @click="deleteCategory(category?.id)"
              path="#"
              :container_id="`btnDeleteCategory-${index}`"
            />
          </TableCell>
        </TableRow>
      </DinamicTable>
      <!-- <Pagination
        :totalItems="currentPagination.totalItems"
        :perPage="parseInt(currentPagination.perPage)"
        :currentPage="parseInt(currentPagination.page)"
        :previousPageLink="currentPagination?.previousPageLink"
        :nextPageLink="currentPagination?.nextPageLink"
        @page-changed="fetchCategories"
      /> -->
    </Card>
  </section>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import Button from "@/components/buttons/Button.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableButtonEdit from "@/components/atoms/table/TableButtonEdit.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import AlertSuccess from "@/components/alerts/AlertSuccess.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import ModalAddEditCategory from "@/components/modals/ModalAddEditCategory.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Category",
  components: {
    Card,
    PageHeader,
    Button,
    DinamicTable,
    TableRow,
    TableCell,
    TableButtonEdit,
    TableButtonDelete,
    TableButtonView,
    AlertSuccess,
    AlertDanger,
    AlertConfirmation,
    Pagination,
    ModalAddEditCategory
  },
  data() {
    return {
      table_header: [
        "No",
        "Name",
        "Action",
      ],

      alert_success: false,
      alert_text: "",
      category_to_edit: null,
      category_id_to_delete: null,
      modalShowAddEditCategory: false,

      alert_confirmation: false,
      animation_alert_confirmation_class: "",
    };
  },
  async created() {
    await this.$store.dispatch("categories/fetchCategories");
  },
  computed: {
    ...mapGetters("categories", ["allCategories", "pagination"]),
  },
  methods: {
    ...mapActions("categories", ["createCategory", "updateCategory", "deleteCategoryById"]),

    showModalAddEditCategory() {
      this.category_to_edit = null;
      this.modalShowAddEditCategory = true;
    },

    async editCategory(category) {
      this.category_to_edit = category;
      this.modalShowAddEditCategory = true;
    },

    async closeModalAddEditCategory() {
      this.modalShowAddEditCategory = false;
      await this.$store.dispatch("categories/fetchCategories");
    },
    handle_clicked_no() {
      this.alert_confirmation = false;
      this.category_id_to_delete = null;
    },

    deleteCategory(id) {
      this.category_id_to_delete = id;
      this.alert_confirmation = true;
    },
    async handle_clicked_yes() {
      await this.deleteCategoryById(this.category_id_to_delete);
      this.alert_confirmation = false;
      this.category_id_to_delete = null;
      await this.$store.dispatch("categories/fetchCategories");
    },

    showAlertSuccess(text) {
      this.alert_success = true;
      this.alert_text = text;
      setTimeout(() => {
        this.alert_success = false;
      }, 1500);
    },

    openAlert_CategoryCreated() {
      this.showAlertSuccess("Category added successfully!");
    },
    openAlert_CategoryUpdated() {
      this.showAlertSuccess("Category updated successfully!");
    },
  }
}
</script>